import { assign, type ContextFrom } from 'xstate';

import { type AuthModel, type CurrentCustomerContextData } from '../../AuthMachine.model';

// ─────────────────────────────────────────────────────────────────────────────

export const setCurrentCustomerData = assign<AuthContext>((_context, event) => {
  const eventWithCustomerData = event as MaybeEventWithCustomerData;

  if (eventWithCustomerData.type !== 'done.invoke.fetchCustomer') return {};

  const currentCustomer = eventWithCustomerData.data;

  return currentCustomer ? { currentCustomer } : {};
});

export const resetCurrentCustomerData = assign<AuthContext>(() => {
  return { currentCustomer: null };
});

// ─── Types ───────────────────────────────────────────────────────────────────

type AuthContext = ContextFrom<typeof AuthModel>;

type MaybeEventWithCustomerData = Readonly<{
  type: string;
  data?: CurrentCustomerContextData;
}>;
